import { _,Foundation,Radio,Backbone,$ } from '../../vendor'
import Biscuit from '../utils/Biscuit'
import User from '../models/User'
import OffCanvasUsersForm from './users/OffCanvasUsersForm'
import InboomaBaseView from './InboomaBaseView'
import Inboomai18n from '../utils/Inboomai18n'

import TopBarMenuTpl from '../templates/TopBarMenuTpl.html'

//import controllers for mobile sub-menus
import OrdersControllerAccessBarMap from '../controllers/OrdersControllerAccessBarMap';
import ContingentsControllerAccessBarMap from '../controllers/ContingentsControllerAccessBarMap';
import UsersController from '../controllers/UsersController';
import VouchersController from '../controllers/VouchersController';
import { getInitialView, isViewVisible, isMaintabVisible } from '../utils/ViewSettings';
import {getContentModifications} from "../App";

export default InboomaBaseView.extend({

    el : '#inb-menu-spot',
    template : TopBarMenuTpl,

    model : {
        '_rbac' : {
            "admin" : {
              "read" : true,
            },
            "manager" : {
              "read" : true,
            },
            "booking-manager" : {
                "read" : true,
            },
            "manager-location" : {
              "read" : true,
            },
            "user" : {
                "read" : true,
            },
            "garage-staff" : {
                "read" : true,
            },
            "mediator" : {
                "read" : true,
            },
            "support" : {
                "read" : false,
            }
        }
    },

    ui : {
        'logout' : '#user-logout',
        'dropdown' : '#inb-user-dd',
        'mobileMenu': '#inb-mobile-menu',
        'mobileMenuIcon': '#inb-menu__mobile',
        'openUserForm' : '#user-form',
        'openEmailSettings' : '#user-email-settings',
        'openSettings': '#settings',
        'changeLang' : '#change-lang'
    },

    events : {
        'click a' : '_closeDropdown',
        'click @ui.logout' : '_closeSession',
        'click @ui.openUserForm' : '_openActiveUserForm',
        'click @ui.openEmailSettings' : '_openEmailSettings',
        'click @ui.openSettings' : '_openSettings',
        'change @ui.changeLang' : '_changeLang'
    },

    templateContext () {
        let contingentsSubMenuItems = ContingentsControllerAccessBarMap();
        let ordersSubMenuItems = OrdersControllerAccessBarMap();

        let usersController = new UsersController();
        let userSubMenuItems = usersController._accessBarMap();
        
        let vouchersController = new VouchersController();
        let vouchersSubMenuItems = vouchersController._accessBarMap();
        
        let dashboard = {};
        let resources = {};
        let appointments = {};

        let subItemsMenu = {
            dashboard: dashboard,
            contingents: contingentsSubMenuItems,
            reservationsList: ordersSubMenuItems,
            resources: resources,
            users: userSubMenuItems.linksMap,
            appointments: appointments,
            vouchers: vouchersSubMenuItems.linksMap
        };
        return {
            _,
            cookies : Biscuit,
            languages : Inboomai18n.getAllLanguages(),
            subMenus: subItemsMenu,
            isViewVisible,
            isMaintabVisible,
            getContentModifications,
        };
    },

    _changeLang () {
        this.app.trigger('change:language', this.getUI('changeLang').val());
    },

    /** 
     * Request data for logged in user,
     * then render the native users form
     * 
     * @todo If user.role !== 'user': Save edited
     * user to global users-collection (if available)
     */
    _openActiveUserForm (e) {

        e.preventDefault();

        const that = this,
              user = new User({ id : Biscuit.get('user.id') })

        user.fetch({
            success (model, response) {

                that._dropdown.close();
                model = new User(response.data);

                const userForm = new OffCanvasUsersForm({
                  model
                });

                // Disable routing after closing form
                userForm.parentView = '';
                userForm.afterCloseTriggerNavigate = false;

            },
            error () {
                alert('Could not load the logged in user. Please try again later.');
            }
        });

        return false;
    },

    _openEmailSettings (e) {

        e.preventDefault();
        let actPath= document.location.pathname;
        document.location="/usersExtension/mailSettings?" + "path=" + actPath;

        return false;
    },

    _openSettings (e) {

        e.preventDefault();
        let actPath= document.location.pathname;
        document.location="/settings?" + "path=" + actPath;

        return false;
    },

    _activeLink : null,

    /**
     * Add "active" class to current open controller-link.
     */
    _displayActiveLink () {

        if (!this._activeLink) {
            return;
        }

        let liTarget;
                  
        if (this._activeLink == 'reservationsList') {
            liTarget = document.querySelector('.top-bar-left .menu li.l-orders');
        } else if (this._activeLink === 'calendars') {
            liTarget = document.querySelector('.top-bar-left .menu li.l-appointments');
        } else {
            liTarget = document.querySelector(`.top-bar-left .menu li.l-${this._activeLink}`);
        }

        // this works only if there is one single controller for one top-bar entry
        // Set top bar link to active
        if (liTarget) {

            const liActive = document.querySelector('.top-bar-left .menu li.active');

            if (liActive) {
                liActive.classList.remove('active');
            }
            
            liTarget.classList.add('active');
        }

    },

    _removeMenuActiveClass () {
        this.ui['mobileMenu'].find('.active').removeClass('active');
    },

    _setMenuActiveClass (e) {
        if (e !== undefined) $(e.currentTarget).addClass('active');
    },

    _toggleMobileMenu () {
        this.ui['mobileMenuIcon'].click();
    },

    _setInitialMenuActive () {
        let currentPath = window.location.pathname;
        if (currentPath == '/') currentPath += getInitialView();
        if (this.ui['mobileMenu'].is(':visible')) this._toggleMobileMenu();

        this._removeMenuActiveClass();

        let currentMenuItem = this.ui['mobileMenu'].find(`[data-link="${currentPath}"]`).get(0);
        if (!currentMenuItem || currentPath == '/dashboard') this._collapseSubMenu();

        this._setMenuActiveClass({currentTarget: currentMenuItem});
    },

    _collapseSubMenu () {
        let expandedMenu = this.ui['mobileMenu'].find('[aria-expanded="true"]');
        if (expandedMenu.length > 0) {
            expandedMenu.children('ul').hide();
            expandedMenu.attr("aria-expanded","false");
        }
    },

    initialize () {

        const that = this;  

        this.app = Radio.channel('app');

        this.app.on('router:execute', (from, to) => {
                if (Biscuit.get('user.role') !== 'support') {
                    that._activeLink = to.controllerName;
                    that._displayActiveLink();
                    that._setInitialMenuActive();
                }

        });

        this.render();

        this._dropdown = new Foundation.Dropdown(this.getUI('dropdown'));

        // display tasks assigned to current user
        if (isViewVisible('tasks') === true) {
            let taskCount = 0;
            const user_id = Biscuit.get('user.id');
            const RequestHelper = Backbone.Model.extend({ urlRoot : '/tasks?page=1&assignee=' + user_id + '&find=!Done' });

            (new RequestHelper()).fetch({
                success (model, response) {
                    taskCount = model.attributes.pagination.count;

                    var el, el_array = document.getElementsByClassName('inb-menu--user-message-info');
                    if (el_array !== undefined && el_array != null) {
                        for (var i=0;i<el_array.length;i++) {
                            el_array[i].className = (taskCount === 0) ? "inb-menu--user-message-info hidden" : "inb-menu--user-message-info";
                            for(var j=0;j<el_array[i].childNodes.length;j++) {
                                if (el_array[i].childNodes[j].className === "info-box") {
                                    el_array[i].childNodes[j].innerHTML = taskCount;
                                }
                            }
                        }
                    }
                    el = document.getElementById('inb-menu--user-tasks-count');
                    if (el !== undefined && el != null) {
                        el.className = (taskCount == 0) ? "hidden" : "";
                        el.innerHTML += taskCount == 0 ? "" : (" " + taskCount);
                    }
                    el = document.getElementById('tasks_count1');
                    if (el !== undefined && el != null) {
                        el.className = (taskCount == 0) ? "hidden" : "";
                        el.innerHTML += taskCount == 0 ? "" : (" " + taskCount);
                    }
                    el = document.getElementById('tasks_count2');
                    if (el !== undefined && el != null) {
                        el.className = (taskCount == 0) ? "hidden" : "";
                        el.innerHTML += taskCount == 0 ? "" : (" " + taskCount);
                    }
                }
            });
        }
    },

    onRender () {

        const that = this;

        // hide email-settings for user 'cause they don't have settings yet
        if (Biscuit.get('user.role') == 'user') {
            that.$('#user-email-settings').addClass('hide');
          // that.$('#open-sales-billings').addClass('hide');
        }


        // show warning when using Internet Explorer
        if (Biscuit.get('user.role') != 'support') {
            if (window.navigator.userAgent.indexOf("MSIE ") >= 0) {
                var menu = document.getElementById('inb-menu');
                var warning = document.createElement('div');
                warning.className = "top-bar-warning off-canvas__form-error fi fi-alert";
                warning.innerHTML = this.t('IE_not_supported_warning');
                menu.parentNode.insertBefore(warning, menu);
            }
            this._displayActiveLink();
            that._setInitialMenuActive();
        }
    },

    _closeDropdown () {
        this._dropdown.close();
        return true;
    },

    _closeSession () {
        const RequestHelper = Backbone.Model.extend({ urlRoot : '/users/logout' });

        (new RequestHelper()).fetch({
            success(model, response) {

            }
        });
        this.app.trigger('destroy:session');
    }

});
